<div class="progress" *ngIf="(isProgressBar$ | async); else spin" [ngClass]="stateClass$ | async"
  [style.width]="progress$ | async"></div>
<ng-template #spin>
  <div *ngIf="!closed">
    <div class="spin"></div>
    <div class="spin-close" *ngIf="closeable" title="Close the mask"><i class="fa fa-times fa-2x"
        (click)="closeSpinLoading()"></i></div>
    <div class="mask" [ngClass]="{'spin-mask':!(isProgressBar$ | async)}"></div>
  </div>
</ng-template>